<div class="create-property">
  <div class="container">
    <div class="create-property-sec">
      <div class="page-title mb-3">
        <h3 class="text-center">Prompts</h3>
      </div>
      <div class="create-property-form">
        <p-dropdown [options]="prompts" [(ngModel)]="selectedPrompt" optionLabel="slug" (onChange)="fillForm()"
          placeholder="Select Prompt To Modify" [showClear]="true" class="w-full"></p-dropdown>

        <form [formGroup]="promptForm" (ngSubmit)="updatePrompt()">
          <div class="row">
            <div class="col-6">
              <div class="form-group mb-2">
                <label for="slug">Slug</label>
                <input pInputText class="w-100" id="slug" formControlName="slug" type="text" [disabled]="true" [readonly]="true"/>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="content">Prompt</label>
                <textarea rows="20" id="content" pInputTextarea name="content" formControlName="content" class="form-control"></textarea>
              </div>
            </div>
            <div class="col-12">
              <div class="btn-container d-flex justify-content-end">
                <p-button type="submit" class="secondary-btn" [disabled]="promptForm.invalid">Update Prompt</p-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<p-toast></p-toast>